module.exports = __webpack_public_path__ + "static/media/talea-logo-white.9bd8c9f2.png";